import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../../utils/rem'
import COVER from '../../utils/COVER'

//import 'normalize.css'
import '../../assets/less/common.less'
import '../../assets/icon/iconfont.css'

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development') {
    Vue.config.devtools = true;
} else {
    Vue.config.devtools = false;
}

Vue.prototype.$track = COVER.yunTrack;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
